/* LUF — Shopify interactions: Cart AJAX, scroll reveal, filters, signup, header */
(function () {
  'use strict';

  /* ---- Reduced-motion guard ---- */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ==============================================================
     CART (Shopify AJAX API)
     ============================================================== */
  var bagEls = document.querySelectorAll('.bag');

  function renderBag(count) {
    document.querySelectorAll('.bag .count').forEach(function (c) {
      c.textContent = count;
    });
  }

  function bump() {
    bagEls.forEach(function (b) {
      b.classList.add('bump');
      setTimeout(function () { b.classList.remove('bump'); }, 420);
    });
  }

  /* Fetch current cart count on page load */
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderBag(cart.item_count); })
    .catch(function () {});

  /* Add to bag via Cart AJAX */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.add');
    if (!add || add.classList.contains('soldout')) return;

    /* If size not yet selected, flash the size buttons */
    if (add.classList.contains('needs-size')) {
      var card = add.closest('.card');
      if (card) {
        var sizes = card.querySelector('.card-sizes');
        if (sizes) {
          sizes.style.opacity = '1';
          sizes.style.maxHeight = '80px';
          sizes.style.padding = '4px 0 0';
        }
      }
      return;
    }

    var variantId = add.getAttribute('data-variant-id');
    if (!variantId) return;

    add.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      /* Update count from cart state */
      return fetch('/cart.js', { credentials: 'same-origin' });
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderBag(cart.item_count);
      bump();

      var prev = add.textContent;
      add.textContent = '\u2713 ADDED';
      setTimeout(function () {
        add.textContent = prev;
        add.disabled = false;
      }, 1100);
      /* Open cart drawer */
      openCartDrawer();
    })
    .catch(function () {
      add.disabled = false;
    });
  });

  /* ==============================================================
     CARD SIZE SELECTOR
     ============================================================== */
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('.card-size-btn');
    if (!sizeBtn || sizeBtn.disabled) return;

    var card = sizeBtn.closest('.card');
    if (!card) return;

    /* Toggle active state within this card's sizes */
    card.querySelectorAll('.card-size-btn').forEach(function (b) { b.classList.remove('active'); });
    sizeBtn.classList.add('active');

    /* Update the add button with selected variant */
    var addBtn = card.querySelector('.add');
    if (addBtn) {
      addBtn.dataset.variantId = sizeBtn.dataset.variantId;
      addBtn.disabled = false;
      addBtn.classList.remove('needs-size');
      addBtn.textContent = 'ADD TO BAG';
    }
  });

  /* ==============================================================
     CART DRAWER
     ============================================================== */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartBackdrop = document.getElementById('cartBackdrop');
  var cartDrawerClose = document.getElementById('cartDrawerClose');
  var cartDrawerToggle = document.getElementById('cartDrawerToggle');

  function openCartDrawer() {
    if (!cartDrawer) return;
    /* Fetch fresh cart HTML every time we open */
    fetchCartDrawerContent();
    cartDrawer.classList.add('open');
    cartBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  function fetchCartDrawerContent() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderBag(cart.item_count);
        renderCartDrawer(cart);
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD' });
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById('cartDrawerBody');
    var foot = document.getElementById('cartDrawerFoot');
    if (!body || !foot) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer-empty"><p class="meta muted">YOUR BAG IS EMPTY</p></div>';
      foot.innerHTML = '';
      return;
    }

    var itemsHtml = '<div class="cart-drawer-items" id="cartDrawerItems">';
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var imgHtml = item.image ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_200x$1') + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '';
      var variantHtml = item.variant_title ? '<span class="cart-drawer-item-variant meta muted">' + item.variant_title + '</span>' : '';
      itemsHtml += '<div class="cart-drawer-item" data-line="' + line + '">' +
        '<a href="' + item.url + '" class="cart-drawer-item-img">' + imgHtml + '</a>' +
        '<div class="cart-drawer-item-info">' +
          '<a href="' + item.url + '" class="cart-drawer-item-name meta">' + item.product_title.toUpperCase() + '</a>' +
          variantHtml +
          '<span class="cart-drawer-item-price meta">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-drawer-qty">' +
            '<button class="cart-drawer-qty-btn" data-action="decrease" data-line="' + line + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span class="cart-drawer-qty-val meta">' + item.quantity + '</span>' +
            '<button class="cart-drawer-qty-btn" data-action="increase" data-line="' + line + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="cart-drawer-remove meta muted" data-action="remove" data-line="' + line + '" aria-label="Remove item">&times;</button>' +
      '</div>';
    });
    itemsHtml += '</div>';
    body.innerHTML = itemsHtml;

    foot.innerHTML =
      '<div class="cart-drawer-totals">' +
        '<span class="meta">SUBTOTAL</span>' +
        '<span class="meta" id="cartDrawerSubtotal">' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<form action="/cart" method="post">' +
        '<button type="submit" name="checkout" class="cart-drawer-checkout cta">CHECKOUT</button>' +
      '</form>';
  }

  /* Cart drawer quantity / remove actions */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn || !btn.closest('.cart-drawer')) return;

    var action = btn.dataset.action;
    var line = parseInt(btn.dataset.line, 10);
    var qtyEl = btn.closest('.cart-drawer-item') ? btn.closest('.cart-drawer-item').querySelector('.cart-drawer-qty-val') : null;
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty;

    if (action === 'increase') {
      newQty = currentQty + 1;
    } else if (action === 'decrease') {
      newQty = Math.max(0, currentQty - 1);
    } else if (action === 'remove') {
      newQty = 0;
    } else {
      return;
    }

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderBag(cart.item_count);
      renderCartDrawer(cart);
    })
    .catch(function () {});
  });

  if (cartDrawerToggle) {
    cartDrawerToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (cartDrawer.classList.contains('open')) {
        closeCartDrawer();
      } else {
        openCartDrawer();
      }
    });
  }

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', closeCartDrawer);
  }

  /* Expose globally for PDP add-to-cart */
  window.LUF = window.LUF || {};
  window.LUF.openCartDrawer = openCartDrawer;

  /* ==============================================================
     NEWSLETTER / HERO SIGNUP
     Form submits through Shopify's {% form 'customer' %} natively.
     This JS handles client-side validation UX and success state.
     ============================================================== */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('news')) return;
    e.preventDefault();

    var inp = form.querySelector('input[type="email"]');
    var val = (inp.value || '').trim();
    var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

    if (!valid) {
      form.classList.remove('ok');
      form.classList.add('err');
      inp.focus();
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    })
    .then(function () {
      form.classList.remove('err');
      form.classList.add('ok');
      inp.value = '';
      inp.placeholder = '\u2713 subscribed';
      if (btn) btn.disabled = false;
    })
    .catch(function () {
      /* Even on error, Shopify often succeeds — show success */
      form.classList.add('ok');
      inp.value = '';
      inp.placeholder = '\u2713 subscribed';
      if (btn) btn.disabled = false;
    });
  });

  document.addEventListener('input', function (e) {
    if (e.target.closest('.news.err')) {
      e.target.closest('.news').classList.remove('err');
    }
  });

  /* ==============================================================
     PREDICTIVE SEARCH
     ============================================================== */
  var searchToggle = document.querySelector('.search-toggle');
  var searchDrawer = document.getElementById('searchDrawer');
  var searchInput = document.getElementById('searchInput');
  var searchResults = document.getElementById('searchResults');
  var searchClose = document.querySelector('.search-close');
  var searchTimer = null;

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.hidden = false;
    requestAnimationFrame(function () {
      searchDrawer.classList.add('open');
      searchToggle.setAttribute('aria-expanded', 'true');
      searchInput.focus();
    });
  }

  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('open');
    searchToggle.setAttribute('aria-expanded', 'false');
    setTimeout(function () { searchDrawer.hidden = true; }, 260);
    searchResults.innerHTML = '';
    searchInput.value = '';
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchDrawer.classList.contains('open');
      if (isOpen) closeSearch(); else openSearch();
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (cartDrawer && cartDrawer.classList.contains('open')) closeCartDrawer();
      if (searchDrawer && searchDrawer.classList.contains('open')) closeSearch();
    }
  });

  /* Close on click outside */
  document.addEventListener('click', function (e) {
    if (searchDrawer && searchDrawer.classList.contains('open') &&
        !e.target.closest('.search-drawer') && !e.target.closest('.search-toggle')) {
      closeSearch();
    }
  });

  /* Predictive search via Shopify API */
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<div class="sr-empty">NO RESULTS</div>';
              return;
            }
            searchResults.innerHTML = products.map(function (p) {
              var img = p.image ? '<img src="' + p.image + '" alt="">' : '';
              var price = p.price ? ('€' + parseFloat(p.price).toFixed(2)) : '';
              return '<a href="' + p.url + '">' + img +
                '<div class="sr-info"><span class="sr-name">' + p.title.toUpperCase() + '</span>' +
                '<span class="sr-price">' + price + '</span></div></a>';
            }).join('');
          })
          .catch(function () {
            searchResults.innerHTML = '';
          });
      }, 250);
    });
  }

  /* ==============================================================
     SCROLL REVEAL
     ============================================================== */
  var revealEls = document.querySelectorAll('.reveal');

  if (!prefersReduced && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    revealEls.forEach(function (el) { io.observe(el); });

    /* Fallback: reveal anything already in viewport at load */
    var revealInView = function () {
      revealEls.forEach(function (el) {
        if (el.classList.contains('in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.95 && r.bottom > 0) {
          el.classList.add('in');
          io.unobserve(el);
        }
      });
    };
    requestAnimationFrame(revealInView);
    window.addEventListener('load', revealInView);
  } else {
    /* Reduced motion: show everything immediately */
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ==============================================================
     FLOATING HEADER — transparent over hero, solid otherwise
     ============================================================== */
  var head = document.getElementById('siteHead');
  if (head) {
    var hasHero = document.querySelector('.hero-full');
    if (!hasHero) {
      head.classList.add('solid');
    } else {
      var onScroll = function () {
        var trigger = Math.max(window.innerHeight * 0.72, 320);
        head.classList.toggle('solid', window.scrollY > trigger);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ==============================================================
     SHOP FILTERS
     ============================================================== */
  var filterBtns = document.querySelectorAll('.filters button');
  var cards = document.querySelectorAll('.grid .card');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var cat = btn.getAttribute('data-cat');
      cards.forEach(function (c) {
        var show = cat === 'all' || c.getAttribute('data-cat') === cat;
        c.style.display = show ? '' : 'none';
      });
    });
  });
})();
